$(function () {
  // LINEテンプレート切替
  $('#js-template-title').on('change', (e) => {
    const body = $(e.target).val();
    $('#js-template-body').val(body);
    characterLimitCecker ();
  });
  // テキスト入力時
  $('#js-template-body').on('keyup', characterLimitCecker);
  // 画面読み込み時
  characterLimitCecker ();
  
  function characterLimitCecker () {
    if ($('#js-template-body').length == 0) return;
    // 改行は２文字扱い
    // 「---本メッセージに対して返信することは出来ません」（２７文字）分を加算
    let count = $('#js-template-body').val().replace(/\n/g, '改行').length + 27;
    if (count > 5000) {
      $('.text-counter').css('color', 'red');
      $('[type="submit"]').prop('disabled', true);
    } else {
      $('.text-counter').css('color', 'black');
      $('[type="submit"]').prop('disabled', false);
    }
    // カウンター
    $('.text-counter').text(count + ' / 5000文字');
  }
});
